
import Datetime from 'vux/src/components/datetime/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Countup from 'vux/src/components/countup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'


export default {
components: {
Datetime,
PopupPicker,
Countup,
Popup,Group,PopupHeader,XButton,Radio
},
directives: {
TransferDom
},
data() {
return {
type:1,
showDates:false,
pickerStatus:false,
dateStatus:false,
index:0,
startDate:'',
endDate:'',
info:{},
list:[],
operateArr:[
{
key:1,
title:'入厂统计',
},
{
key:2,
title:'打包统计',
},
{
key:3,
title:'出厂统计',
},
],
}
},
created(){
this.type = Number(this.$route.params.type) > 0 ? this.$route.params.type : 1;
console.log(this.type);


this.setDate();
setTimeout(() => {
this.getData();
}, 300);
},
methods: {
operate(key){
this.type = key;
this.getData();
},
setDate() {
this.startDate = this.$func.getCurrentDate();
this.endDate = this.$func.getCurrentDate();
},
showDate(e){
this.index = e;
this.dateStatus = true;
},
previous(){
this.startDate = this.$func.modifyDate(this.startDate,-1);
this.endDate = this.startDate;
this.getData();
},
next(){
this.startDate = this.$func.modifyDate(this.startDate,1);
this.endDate = this.startDate;
this.getData();
},
dateChange(e){
if(this.index > 0){
this.endDate = e;
}else{
this.startDate = e;
}



},
reset(){
this.setDate();
setTimeout(() => {
this.getData();
}, 300);
},
getData() {
if(!this.startDate || !this.endDate){
this.$func.showToast('请选择日期');
return;
}
this.$func.startLoading();
this.$api.contractFactoryUserData({status:this.type,start:this.startDate,end:this.endDate}).then((res)=>{
if(res){
this.list = res.data.list;
this.info = res.data;
this.$func.endLoading();
}
})
},
}
}



// WEBPACK FOOTER //
// ./src/pages/inFactoryUserData.vue